import React from "react";
import LogoSVG from "../logo/logo";
import {Link} from "gatsby";
import "./navigation-bar.css"

const MenuLink = ({children, to}: {children: React.ReactNode, to: string}) => {

    return <Link to={to} className={'nav-link heading-6 uppercase'}>
        {children}
    </Link>

}

const NavigationBar = () => {

    const MENU: any[] = [
        // {
        //
        //     title: "Our Menu",
        //     to: "/menu",
        //     side: "left"
        // },
        // {
        //     title: "Order Now",
        //     to: "/order",
        //     side: "left"
        // },
        // {
        //     title: "Catering",
        //     to: "/catering",
        //     side: "right"
        // },
        // {
        //     title: "Contact Us",
        //     to: "/contact-us",
        //     side: "right"
        // }
    ]

    return (
        <header className={"fixed top-0 h-24 w-full z-40 nav-header flex items-center justify-center"}>

            {MENU.map((menu, index) => (
                <React.Fragment key={index}>
                    {menu.side === "left" && <MenuLink to={menu.to}>{menu.title}</MenuLink>}
                </React.Fragment>
            ))}

            <Link to={"/"}>
                <LogoSVG className={'w-24 transform -translate-y-1 mx-12 fill-primary'} />
            </Link>

            {MENU.map((menu, index) => (
                <React.Fragment key={index}>
                    {menu.side === "right" && <MenuLink to={menu.to}>{menu.title}</MenuLink>}
                </React.Fragment>
            ))}

        </header>
    )

}

export default NavigationBar